import { MessageDirection, MessageResponse } from "client/openapi";
import "./index.css";

/**
 * A copy of an email a staff member sent from their own mailbox, outside
 * Tadpole: outbound, with the address it was sent from.
 */
export function isOwnEmailCopy(message: MessageResponse) {
  return (
    message.direction === MessageDirection.OUTBOUND && !!message.sender_email
  );
}

/**
 * Shows how a message left (or entered) the system:
 * - "Internal Log" for outbound messages that were recorded but never
 *   texted or emailed (the org's notification preference was off)
 * - "Sent · Text/Email" for outbound messages actually sent to a channel
 * - "Sent · Own email" for emails staff sent from their own mailbox
 * - "Received · Text/Email" for inbound messages
 */
export function MessageDeliveryTag({ message }: { message: MessageResponse }) {
  if (isOwnEmailCopy(message)) {
    return (
      <span
        className="delivery-tag sent"
        title={`Sent from ${message.sender_email}, not through Tadpole`}
      >
        Sent · Own email
      </span>
    );
  }

  const channel =
    message.sms && message.email
      ? "Text + Email"
      : message.sms
      ? "Text"
      : message.email
      ? "Email"
      : null;

  if (message.direction === MessageDirection.INBOUND) {
    return channel ? (
      <span className="delivery-tag sent">Received · {channel}</span>
    ) : null;
  }

  return channel ? (
    <span className="delivery-tag sent">Sent · {channel}</span>
  ) : (
    <span className="delivery-tag internal">Internal Log</span>
  );
}
